import React, { memo } from "react";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

export const DataPoints = memo(function DataPoints() {
  const data_points = useSelector((state) => state.membershipLengthByAgreement.table?.data_points);
  const { qa } = useSelector((state) => state.commonReducer.commonProps);

  if (!data_points || !data_points.length) return null;

  return (
    <div className="data-points">
      {data_points.map((dataPoint) => {
        return (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay
              disableAnimation={qa}
              key={dataPoint.label}
              label={dataPoint.label}
              value={dataPoint.count}
              url={dataPoint.url}
              decimal={dataPoint.decimal}
              type="default"
            />
          </div>
        );
      })}
    </div>
  );
});
